import { render } from "./lightbox.vue?vue&type=template&id=f9e11f7c&ts=true"
import script from "./lightbox.vue?vue&type=script&lang=ts"
export * from "./lightbox.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__